export const Theme = {
    FIRST_COLOR: '#265579',
    SECOND_COLOR: '#D6DA00',
    THIRD_COLOR: '#FFFFFF',
    FIRST_FONT: "'Open Sans', sans-serif",
    SECOND_FONT: "'Comic Neue', cursive",
    THIRD_FONT: "'Bebas Neue', cursive",
}